import { render, staticRenderFns } from "./CreateSpaceForm.vue?vue&type=template&id=3b9b4e62&"
import script from "./CreateSpaceForm.vue?vue&type=script&lang=js&"
export * from "./CreateSpaceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports